export const paidPlan = (featurePlan) => featurePlan.price_cents_usd >= 50;

export const canAccessFeature = (featurePlan, feature) => {
    if (!featurePlan || !feature) return false;
    if (!feature.onlyPaid) return true;
    return paidPlan(featurePlan);
};